import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Orders from './components/Orders';

const orders = (props,{ t }) => (
  <Container>
    <Orders {...props} />
  </Container>
);

orders.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(orders);
